import { Box, Typography } from "@mui/material";

import DashboardPanel from "./DashboardPanel";
import CustomDashboard from "./CustomDashboard";
import Embeded from "./Embeded";

import { customDashboards } from "../dashboards";

import { DashboardInfo } from "../utils/types";
import DashboardHeader from "./DashboardHeader";
import { DashboardFilterProvider } from "../contexts/DashboardFilterContext";

interface PrimaryDashboardProps {
  readonly dashboardInfo: DashboardInfo;
}

export default function PrimaryDashboard({
  dashboardInfo,
}: PrimaryDashboardProps) {
  let dashboardContent;

  const customDashboard = customDashboards[dashboardInfo.id];

  if (customDashboard) {
    if (customDashboard.Component) {
      dashboardContent = (
        <customDashboard.Component dashboardId={dashboardInfo.id} />
      );
    } else {
      dashboardContent = (
        <DashboardFilterProvider filters={customDashboard.filters}>
          <CustomDashboard id={dashboardInfo.id} hideTitle hideFilter />
        </DashboardFilterProvider>
      );
    }
  } else if (dashboardInfo?.dashboard_uuid) {
    dashboardContent = <Embeded dashboardInfo={dashboardInfo} />;
  } else {
    dashboardContent = <Typography></Typography>;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <DashboardPanel>
        <>
          {dashboardInfo && (
            <DashboardHeader
              dashboardInfo={dashboardInfo}
              hideBreadcrumbs
              hideSectionMenu
              showTimeline={customDashboard?.showTimeline}
            />
          )}
          {dashboardContent}
        </>
      </DashboardPanel>
    </Box>
  );
}
